export default "/6f5960d261b7037536f8040edbfa0172.png";